export const CLOUD_FEATURE_FLAGS = {
  cloudCampaignsEnabled: false,
  cloudGrindsEnabled: process.env.REACT_APP_ENABLE_CLOUD_GRINDS === 'true',
  controlledPaidDiscoveryEnabled: process.env.REACT_APP_ENABLE_CONTROLLED_PAID_DISCOVERY === 'true'
};

export const CONTROLLED_CLOUD_GRIND_TEST_CAMPAIGN_ID =
  process.env.REACT_APP_CLOUD_GRIND_TEST_CAMPAIGN_ID || '';

export const CONTROLLED_CLOUD_GRIND_TEST_MARKER = 'controlled-cloud-grind-test';

export const CLOUD_COLLECTIONS = {
  users: 'users',
  campaigns: 'campaigns',
  campaignCompletions: 'campaignCompletions',
  campaignFeedback: 'campaignFeedback',
  campaignGrinds: 'campaignGrinds',
  campaignDiscoverySessions: 'campaignDiscoverySessions',
  campaignCompletionProofs: 'campaignCompletionProofs',
  campaignFunding: 'campaignFunding',
  campaignFundingTransfers: 'campaignFundingTransfers',
  campaignImpressions: 'campaignImpressions',
  campaignRewardClaims: 'campaignRewardClaims',
  campaignAnalyticsEvents: 'campaignAnalyticsEvents',
  signupGrants: 'signupGrants',
  tokenLedger: 'tokenLedger'
};

export const AUDIENCE_TOKEN_RATES = {
  music_fans: 3,
  readers: 4,
  film_tv_fans: 3,
  business_entrepreneurship: 5,
  fashion_beauty: 4,
  food: 3,
  health_fitness: 4,
  technology: 5,
  gaming: 4,
  sports: 3,
  education: 4,
  travel: 4
};

export const AUDIENCE_LABELS = {
  music_fans: 'Music Fans',
  readers: 'Readers',
  film_tv_fans: 'Film & TV Fans',
  business_entrepreneurship: 'Business & Entrepreneurship',
  fashion_beauty: 'Fashion & Beauty',
  food: 'Food',
  health_fitness: 'Health & Fitness',
  technology: 'Technology',
  gaming: 'Gaming',
  sports: 'Sports',
  education: 'Education',
  travel: 'Travel'
};

export const CAMPAIGN_IMPRESSION_STATUS = {
  served: 'served',
  expired: 'expired',
  settled: 'settled'
};

export const CAMPAIGN_IMPRESSION_SETTLEMENT_STATUS = {
  pending: 'pending',
  settled: 'settled',
  expired: 'expired'
};

export const CAMPAIGN_FUNDING_STATUS = {
  unfunded: 'unfunded',
  funded: 'funded',
  insufficientFunds: 'insufficient_funds'
};

export const CAMPAIGN_DELIVERY_STATUS = {
  draft: 'draft',
  active: 'active',
  manuallyPaused: 'manually_paused',
  insufficientFunds: 'insufficient_funds',
  archived: 'archived',
  deleted: 'deleted',
  moderationHold: 'moderation_hold'
};

export const TOKEN_LEDGER_TYPES = {
  signupGrant: 'signup_grant',
  discoveryReward: 'discovery_reward',
  campaignDiscoverySpend: 'campaign_discovery_spend',
  campaignFundingTransfer: 'campaign_funding_transfer',
  tokenPurchase: 'token_purchase',
  adminCorrection: 'admin_correction'
};

export const CLOUD_CAMPAIGN_SOURCE = 'cloud';
export const LOCAL_MIGRATION_SOURCE = 'local-indexeddb';

export function createCampaignViewerId(campaignId, viewerId) {
  return `${requireSafeIdPart(campaignId, 'campaignId')}_${requireSafeIdPart(viewerId, 'viewerId')}`;
}

export function createCampaignCompletionId(campaignId, viewerId) {
  return createCampaignViewerId(campaignId, viewerId);
}

export function createCampaignGrindId(campaignId, viewerId) {
  return createCampaignViewerId(campaignId, viewerId);
}

export function createCampaignRewardClaimId(campaignId, viewerId) {
  return createCampaignViewerId(campaignId, viewerId);
}

export function createCampaignImpressionId({ campaignId, viewerId, servedAt }) {
  return [
    requireSafeIdPart(campaignId, 'campaignId'),
    requireSafeIdPart(viewerId, 'viewerId'),
    requireSafeIdPart(servedAt, 'servedAt')
  ].join('_');
}

export function getUserDocPath(userId) {
  return `${CLOUD_COLLECTIONS.users}/${requireSafeIdPart(userId, 'userId')}`;
}

export function getCampaignDocPath(campaignId) {
  return `${CLOUD_COLLECTIONS.campaigns}/${requireSafeIdPart(campaignId, 'campaignId')}`;
}

export function getCampaignCompletionDocPath(campaignId, viewerId) {
  return `${CLOUD_COLLECTIONS.campaignCompletions}/${createCampaignCompletionId(campaignId, viewerId)}`;
}

export function getCampaignFeedbackDocPath(campaignId, viewerId) {
  return `${CLOUD_COLLECTIONS.campaignFeedback}/${createCampaignCompletionId(campaignId, viewerId)}`;
}

export function getCampaignGrindDocPath(campaignId, viewerId) {
  return `${CLOUD_COLLECTIONS.campaignGrinds}/${createCampaignGrindId(campaignId, viewerId)}`;
}

export function getCampaignDiscoverySessionDocPath(impressionId) {
  return `${CLOUD_COLLECTIONS.campaignDiscoverySessions}/${requireSafeIdPart(impressionId, 'impressionId')}`;
}

export function getCampaignCompletionProofDocPath(impressionId) {
  return `${CLOUD_COLLECTIONS.campaignCompletionProofs}/${requireSafeIdPart(impressionId, 'impressionId')}`;
}

export function getCampaignFundingDocPath(campaignId) {
  return `${CLOUD_COLLECTIONS.campaignFunding}/${requireSafeIdPart(campaignId, 'campaignId')}`;
}

export function getCampaignFundingTransferDocPath(transferId) {
  return `${CLOUD_COLLECTIONS.campaignFundingTransfers}/${requireSafeIdPart(transferId, 'transferId')}`;
}

export function getCampaignImpressionDocPath(impressionId) {
  return `${CLOUD_COLLECTIONS.campaignImpressions}/${requireSafeIdPart(impressionId, 'impressionId')}`;
}

export function getCampaignRewardClaimDocPath(campaignId, viewerId) {
  return `${CLOUD_COLLECTIONS.campaignRewardClaims}/${createCampaignRewardClaimId(campaignId, viewerId)}`;
}

export function getSignupGrantDocPath(userId) {
  return `${CLOUD_COLLECTIONS.signupGrants}/${requireSafeIdPart(userId, 'userId')}`;
}

export function getCampaignAnalyticsEventDocPath(eventId) {
  return `${CLOUD_COLLECTIONS.campaignAnalyticsEvents}/${requireSafeIdPart(eventId, 'eventId')}`;
}

export function getTokenLedgerDocPath(ledgerId) {
  return `${CLOUD_COLLECTIONS.tokenLedger}/${requireSafeIdPart(ledgerId, 'ledgerId')}`;
}

export function getCampaignArtworkPath({ creatorId, campaignId, assetId }) {
  return [
    'campaignArtwork',
    requireSafeIdPart(creatorId, 'creatorId'),
    requireSafeIdPart(campaignId, 'campaignId'),
    requireSafeIdPart(assetId, 'assetId')
  ].join('/');
}

export function isControlledCloudGrindTestCampaignEnabled() {
  return CLOUD_FEATURE_FLAGS.cloudGrindsEnabled && getControlledCloudGrindTestCampaignId() !== '';
}

export function isControlledPaidDiscoveryEnabled() {
  return CLOUD_FEATURE_FLAGS.controlledPaidDiscoveryEnabled && getControlledCloudGrindTestCampaignId() !== '';
}

export function isControlledPaidDiscoveryCampaign(campaign = {}) {
  return isControlledPaidDiscoveryEnabled()
    && campaign.source === CLOUD_CAMPAIGN_SOURCE
    && campaign.id === getControlledCloudGrindTestCampaignId();
}

export function getControlledCloudGrindTestCampaignId() {
  return process.env.REACT_APP_CLOUD_GRIND_TEST_CAMPAIGN_ID || CONTROLLED_CLOUD_GRIND_TEST_CAMPAIGN_ID;
}

export function createCloudCampaignSourceMetadata({ localOriginId = null, legacyPlatform = '', legacyCreatorType = '' } = {}) {
  return {
    source: CLOUD_CAMPAIGN_SOURCE,
    localOriginId: localOriginId || null,
    legacy: {
      platform: legacyPlatform || '',
      creatorType: legacyCreatorType || ''
    }
  };
}

export function createLocalMigrationMetadata(localCampaign = {}) {
  return createCloudCampaignSourceMetadata({
    localOriginId: localCampaign.id || null,
    legacyPlatform: localCampaign.platform || '',
    legacyCreatorType: localCampaign.creatorType || ''
  });
}

function requireSafeIdPart(value, fieldName) {
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`${fieldName} is required.`);
  }

  const trimmed = value.trim();
  if (trimmed.includes('/')) {
    throw new Error(`${fieldName} cannot contain path separators.`);
  }

  return trimmed;
}
